'use client';

import React, { useCallback } from 'react';
import { useTranslation } from '@i18n/client';
import { Layout } from '@components/Layout';
import { useRedirect } from '@hooks/useRedirect';
import { H1 } from '@components/texts';
import classNames from 'classnames';
import { Button } from '@components/Button';
import ThemedIcon from '@components/ThemedIcon';

type Props = {
  statusCode: string;
  redirectUrl?: string | null;
};

const ErrorPage: React.FC<Props> = ({ statusCode, redirectUrl }) => {
  const { t } = useTranslation();
  const { redirect } = useRedirect();

  const handleBackToShop = useCallback(() => {
    redirect(redirectUrl!);
  }, [redirectUrl]);

  return (
    <Layout>
      <div className='fadeIn flex h-full flex-col gap-8 md:min-h-[unset]'>
        <div className='flex h-full flex-col items-center justify-center'>
          <ThemedIcon
            name='non-success'
            className='h-[104px] w-[104px] md:h-[123px] md:w-[123px]'
          />
          <H1 className='!md:text-[32px] !mb-0 mt-8 text-[18px] font-extrabold leading-[21px] md:text-[32px] md:font-semibold'>
            {t('errorPage.title')}
          </H1>
          <div
            className={classNames(
              'mt-4 max-w-[393px] text-center text-base font-normal leading-[19px] text-text-secondary md:mt-8 md:max-w-[696px] md:text-[18px] md:font-medium md:leading-[24px]'
            )}
          >
            {t('errorPage.statusCodeHelper', { statusCode })}
            <div className='mt-2'>{t('errorPage.description')}</div>
          </div>
          <div
            className={classNames(
              'mt-8 flex w-full flex-col items-center justify-center gap-[1.25rem] md:mt-10 md:flex-row'
            )}
          >
            {!!redirectUrl && (
              <Button
                onClick={handleBackToShop}
                label={t('button.goShop')}
                variant='outlined'
                classNameContainer='min-w-[19rem] md:w-auto'
              />
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ErrorPage;
